"use client";
import React from "react";
import { Trash2 } from "lucide-react";
import styles from "../css/components/DeleteButton.module.css"; 

const DeleteButton = ({ onClick }) => {
  return (
    <button
      className={styles.deleteButton}
      onClick={onClick}
      title="Delete Medication"
    >
      <Trash2 size={18} color="white" />
    </button>
  );
};

export default DeleteButton;
